export default {
  themePerfoplanning: 'perfoplanning',
  themeDark: 'dark',
  themeCustom: 'custom',
  themeLabel(label) {
    switch(label) {
      case this.themePerfoplanning:
        return Core.Definition.getDefinition('Perfoplanning');
        break
      case this.themeDark:
        return Core.Definition.getDefinition('Dark');
        break
      case this.themeCustom:
        return Core.Definition.getDefinition('Personnalisé');
        break
    }
  },
  themeOptions(keys) {
    if (keys === undefined) {
      keys = [this.themePerfoplanning, this.themeCustom]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.themeLabel(key)
          }
      )
    }
    return options
  },
  sheet:
      "body .dropdown-item.active {background-color:[primary.color]; border-color:[primary.color];}" +
      "body .dropdown-item:active {background-color:[primary.color]; border-color:[primary.color];}" +
      "body .app-header { background-color:[headbar.backgroundColor]; color:[headbar.color]; } " +
      "body .app-header a.nav-link, body .app-header a.nav-link:hover { color:[headbar.color]; } " +
      "body .bg-login { background-color:[headbar.backgroundColor]; color:[headbar.color]; } " +
      "body .bg-login { background-color:[headbar.backgroundColor]; color:[headbar.color]; } " +
      "body { background-color:[backgroundColor]; }" +
      "body a { color:[primary.color]; }" +
      "body a:hover { color:[primary.color]; }" +
      "body .btn-primary { background-color:[primary.color]; border-color:[primary.color]; }" +
      "body .list-group-item.active { background-color:[primary.color]; border-color:[primary.color]; }" +
      "body .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle { background-color:[primary.color];border-color:#ffffff; }" +
      "body .btn-primary.disabled { background-color:[primary.color];border-color:#ffffff; }" +
      "body .nav-fill .nav-link.active { border-top-color:[primary.color]; }" +
      "body .btn-primary:hover { background-color:[primary.color]; border-color:[primary.color]; }" +
      "body .btn-link { color:[primary.color]; }" +
      "body .card.bg-primary { background-color:[primary.color]!important; border-color:[primary.color]; }" +
      "body .page-item.active .page-link { background-color:[primary.color]; border-color:[primary.color]; }" +
      "body .aside-menu .nav-tabs .nav-link.active { color:[primary.color]; }" +
      "body .sidebar a.nav-link:hover { background-color:[primary.color]; border-color:[primary.color]; }" +
      "body .sidebar a.nav-link.active .nav-icon { color:[primary.color]; }" +
      "body .card { background-color:[card.backgroundColor]; border-color:[card.borderColor]; }" +
      "body .card .v-select .selected-tag { color:[card.color]; }" +
      "body .card .v-select .dropdown-toggle { border-color:[card.borderColor]; }" +
      "body .card .card-body { color:[card.color]; border-color:[card.borderColor]; }" +
      "body .card a { color:[card.color]; }" +
      "body .card .alert.alert-light { background-color:[card.backgroundColor]; color:[card.color]; border-color:[card.borderColor]; }" +
      "body .card .list-group-item { background-color:[card.backgroundColor]; color:[card.color]; border-color:[card.borderColor]; }" +
      "body .card .card-header { background-color:[card.headerBackgroundColor]; color:[card.headerColor]; border-color:[card.borderColor]; }" +
      "body .card .card-header a { color:[card.headerColor]; }" +
      "body .tabs .tab-pane { background-color:[card.backgroundColor]; color:[card.color]; border-color:[card.borderColor]; }" +
      "body .tabs .nav-link.active { background-color:[card.backgroundColor]; color:[card.color]; }" +
      "body .sidebar { background-color:[sidebar.backgroundColor]; }" +
      "body .sidebar .nav-title { color:[sidebar.title.color]; }" +
      "body .sidebar a.nav-link { color:[sidebar.navLink.color]; background-color:[sidebar.navLink.backgroundColor]; }" +
      "body .sidebar a.nav-link.active { color:[sidebar.navLink.activeColor]; background-color:[sidebar.navLink.activeBackgroundColor]; }" +
      "body .table thead { background-color:[table.headerBackgroundColor]; color:[table.headerColor]; }" +
      "body .table tbody { background-color:[table.backgroundColor]; color:[table.color]; }" +
      "body .table tfoot { background-color:[table.footerBackgroundColor]; color:[table.footerColor]; }" +
      "body .breadcrumb { background-color:[headnav.backgroundColor]; color:[headnav.color]; }" +
      "body .breadcrumb .breadcrumb-item a { color:[headnav.linkColor]; }" +
      "body .breadcrumb .breadcrumb-item { color:[headnav.color]; }" +
      "body .app-footer { background-color:[footer.backgroundColor]; color:[footer.color]; }" +
      "body .app-footer a { color:[footer.linkColor]; }" +
      "body .pagination .page-item.disabled .page-link { background-color:[pagination.backgroundColor]; color:[pagination.color]; }" +
      "body .pagination .page-item a.page-link { background-color:[pagination.backgroundColor]; color:[pagination.color]; }" +
      "body .pagination .page-item.active .page-link { border-color:[pagination.activeBackgroundColor]; background-color:[pagination.activeBackgroundColor]; color:[pagination.activeColor]; }",
  customStyle: {
    backgroundColor: {
      hex: ''
    },
    primary: {
      color: {
        hex: ''
      }
    },
    card: {
      headerBackgroundColor: {
        hex: ''
      },
      headerColor: {
        hex: ''
      },
      backgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      },
      borderColor: {
        hex: ''
      }
    },
    table: {
      headerBackgroundColor: {
        hex: ''
      },
      headerColor: {
        hex: ''
      },
      backgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      },
      zebraBackgroundColor: {
        hex: ''
      },
      borderColor: {
        hex: ''
      },
      footerBackgroundColor: {
        hex: ''
      },
      footerColor: {
        hex: ''
      }
    },
    sidebar: {
      backgroundColor: {
        hex: ''
      },
      title: {
        color: {
          hex: ''
        }
      },
      navLink: {
        backgroundColor: {
          hex: ''
        },
        activeBackgroundColor: {
          hex: ''
        },
        color: {
          hex: ''
        },
        activeColor: {
          hex: ''
        }
      }
    },
    headbar: {
      backgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      }
    },
    headnav: {
      backgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      },
      linkColor: {
        hex: ''
      }
    },
    footer: {
      backgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      },
      linkColor: {
        hex: ''
      }
    },
    pagination: {
      backgroundColor: {
        hex: ''
      },
      activeBackgroundColor: {
        hex: ''
      },
      color: {
        hex: ''
      },
      activeColor: {
        hex: ''
      }
    }
  },
  prepareCustomStyles() {
    let styles = false
    if (this.customStyle !== false && this.customStyle.primary !== undefined) {
      styles = [
        {
          key: 'primary.color',
          value: this.customStyle.primary.color.hex
        },
        {
          key: 'backgroundColor',
          value: this.customStyle.backgroundColor.hex
        },
        {
          key: 'headnav.backgroundColor',
          value: this.customStyle.headnav.backgroundColor.hex
        },
        {
          key: 'headnav.color',
          value: this.customStyle.headnav.color.hex
        },
        {
          key: 'headnav.linkColor',
          value: this.customStyle.headnav.linkColor.hex
        },
        {
          key: 'pagination.backgroundColor',
          value: this.customStyle.pagination.backgroundColor.hex
        },
        {
          key: 'pagination.color',
          value: this.customStyle.pagination.color.hex
        },
        {
          key: 'pagination.activeBackgroundColor',
          value: this.customStyle.pagination.activeBackgroundColor.hex
        },
        {
          key: 'pagination.activeColor',
          value: this.customStyle.pagination.activeColor.hex
        },
        {
          key: 'footer.backgroundColor',
          value: this.customStyle.footer.backgroundColor.hex
        },
        {
          key: 'footer.color',
          value: this.customStyle.footer.color.hex
        },
        {
          key: 'footer.linkColor',
          value: this.customStyle.footer.linkColor.hex
        },
        {
          key: 'headbar.backgroundColor',
          value: this.customStyle.headbar.backgroundColor.hex
        },
        {
          key: 'headbar.color',
          value: this.customStyle.headbar.color.hex
        },
        {
          key: 'sidebar.backgroundColor',
          value: this.customStyle.sidebar.backgroundColor.hex
        },
        {
          key: 'sidebar.title.color',
          value: this.customStyle.sidebar.title.color.hex
        },
        {
          key: 'sidebar.navLink.backgroundColor',
          value: this.customStyle.sidebar.navLink.backgroundColor.hex
        },
        {
          key: 'sidebar.navLink.activeBackgroundColor',
          value: this.customStyle.sidebar.navLink.activeBackgroundColor.hex
        },
        {
          key: 'sidebar.navLink.color',
          value: this.customStyle.sidebar.navLink.color.hex
        },
        {
          key: 'sidebar.navLink.activeColor',
          value: this.customStyle.sidebar.navLink.activeColor.hex
        },
        {
          key: 'card.headerBackgroundColor',
          value: this.customStyle.card.headerBackgroundColor.hex
        },
        {
          key: 'card.headerColor',
          value: this.customStyle.card.headerColor.hex
        },
        {
          key: 'card.headerBackgroundColor',
          value: this.customStyle.card.headerBackgroundColor.hex
        },
        {
          key: 'card.backgroundColor',
          value: this.customStyle.card.backgroundColor.hex
        },
        {
          key: 'card.color',
          value: this.customStyle.card.color.hex
        },
        {
          key: 'card.borderColor',
          value: this.customStyle.card.borderColor.hex
        },
        {
          key: 'table.headerBackgroundColor',
          value: this.customStyle.table.headerBackgroundColor.hex
        },
        {
          key: 'table.headerColor',
          value: this.customStyle.table.headerColor.hex
        },
        {
          key: 'table.backgroundColor',
          value: this.customStyle.table.backgroundColor.hex
        },
        {
          key: 'table.color',
          value: this.customStyle.table.color.hex
        },
        {
          key: 'table.zebraBackgroundColor',
          value: this.customStyle.table.zebraBackgroundColor.hex
        },
        {
          key: 'table.borderColor',
          value: this.customStyle.table.borderColor.hex
        },
        {
          key: 'table.footerBackgroundColor',
          value: this.customStyle.table.footerBackgroundColor.hex
        },
        {
          key: 'table.footerColor',
          value: this.customStyle.table.footerColor.hex
        }
      ]
    }
    return styles
  },
  buildSheetFromCustom() {
    let styles = this.prepareCustomStyles()
    if (styles) {
      this.buildSheet(styles)
    }
  },
  buildSheet(styles) {
    let sheet = this.sheet
    for(let style in styles) {
      style = styles[style]
      if(style.value !== '') {
        sheet = sheet.split('[' + style.key + ']').join(style.value)
      }
    }

    this.setStyle('dynamicStyles', sheet)
  },
  resetStyle() {
    let existingStyleElement = document.getElementById('dynamicStyles')
    if (existingStyleElement !== null) {
      document.getElementById('dynamicStyles').remove()
    }
  },
  setStyle(id, sheet) {
    let existingStyleElement = document.getElementById(id)
    if (existingStyleElement !== null) {
      document.getElementById(id).innerHTML = sheet
    } else {
      let styleElement = document.createElement('style')
      styleElement.type = 'text/css'
      styleElement.id = id
      styleElement.innerHTML = sheet
      document.getElementsByTagName('head')[0].appendChild( styleElement );
    }
  }
}
